itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    var module = this;
    var registeredPlugin = false;
    var registeredScrollTriggerPlugin = false;

    var initScrollActions = function (targetCb, scrollTriggerFlag, cb) {
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    gsap.registerPlugin(ScrollTrigger);
                }
            }

            if (cb && typeof cb === "function") {
                cb();
            } else {
                // ScrollTrigger.clearScrollMemory();
                // ScrollTrigger.normalizeScroll(true);

                ScrollTrigger.matchMedia({
                    "(min-width: 1024px)": function () {
                        if (targetCb.classList.contains('js-anim-help')) {
                            const container = targetCb;
                            const items = container.querySelectorAll('.js-anim-help-col');
                            const value = window.innerWidth / 10;

                            const tl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: container,
                                    scrub: true,
                                    start: `top top`,
                                    end: () => "+=" + window.innerHeight,
                                }
                            });

                            for (let index = 0; index < items.length; index++) {
                                const element = items[index];
                                element.style.transitionDuration = '0s'
                                let valueY = value;

                                if (index === 0) {
                                    valueY = value / 1.5;
                                }

                                if (index === 2) {
                                    valueY = value / 3;
                                }

                                tl.fromTo(element, { y: valueY }, { y: -valueY }, "<");
                            }
                        }
                        if (targetCb.classList.contains('js-anim-variants')) {
                            const container = targetCb;
                            const item = container.querySelector('.js-anim-variants-item');
                            const value = 100;

                            const tl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: container,
                                    scrub: true,
                                    start: 'top top',
                                    end: () => "+=" + container.clientHeight,
                                }
                            });

                            let valueY = value;

                            tl.fromTo(item, { y: -valueY }, { y: valueY }, "<");
                        }
                        if (targetCb.classList.contains('js-anim-test')) {
                            const container = targetCb;
                            const items = container.querySelectorAll('.js-anim-test-item');
                            const value = 100;

                            const tl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: container,
                                    scrub: true,
                                    start: `${-window.innerHeight / 2.5} top`,
                                    end: () => "+=" + container.clientHeight,
                                }
                            });

                            for (let index = 0; index < items.length; index++) {
                                const element = items[index];
                                let valueX = value;
                                let valueY = value;

                                if (index === 0) {
                                    valueX = -value;
                                    valueY = -value;
                                }

                                if (index === 1) {
                                    valueX = value;
                                    valueY = -value;
                                }

                                if (index === 2) {
                                    valueX = -value;
                                    valueY = value;
                                }

                                tl.from(element, { x: valueX, y: valueY }, "<");
                            }
                        }
                        if (targetCb.classList.contains('js-anim-advantages')) {
                            const container = targetCb;
                            const items = container.querySelectorAll('.js-anim-advantages-item');
                            const value = window.innerWidth / 5;

                            const tl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: container,
                                    scrub: true,
                                    start: `${-window.innerHeight / 2.5} top`,
                                    end: () => "+=" + container.clientHeight,
                                }
                            });

                            for (let index = 0; index < items.length; index++) {
                                const element = items[index];
                                let valueY = value;

                                if (index === 0 || index === 2 || index === 4) {
                                    valueY = value / 3;
                                }

                                tl.fromTo(element, { y: valueY }, { y: -valueY }, "<");
                            }
                        }
                        if (targetCb.classList.contains('js-anim-about')) {
                            const container = targetCb;
                            const items = container.querySelectorAll('.js-anim-about-item');
                            let itemsHeight = [];
                            let allItemsHeight = 0;
                            const curScale = 0.5;

                            for (let index = 0; index < items.length; index++) {
                                const element = items[index];
                                itemsHeight.push(element.clientHeight)
                            }

                            for (let index = 0; index < itemsHeight.length; index++) {
                                const element = itemsHeight[index];
                                allItemsHeight += element;
                            }

                            function startAnimFirst(ind) {
                                const img = items[ind].querySelector('.about__img');
                                const text = items[ind].querySelector('.about__col');

                                tl.to(img, { scale: curScale, ease: 'linear' });
                                tl.to(text, { y: -itemsHeight[ind], ease: 'linear' }, "<");
                            }

                            function startAnimLast(ind) {
                                tl.to(items[ind], { y: -itemsHeight[ind] * (ind), ease: 'linear' }, "<");
                            }

                            const tl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: container,
                                    pin: true,
                                    scrub: true,
                                    start: 'top top',
                                    end: () => "+=" + (allItemsHeight - itemsHeight[items.length - 1]),
                                    onUpdate: (self) => {
                                        if (self.progress > 0.5) {
                                            items[items.length - 1].classList.add('_active');
                                        } else {
                                            items[items.length - 1].classList.remove('_active');
                                        }
                                    },
                                }
                            });

                            startAnimFirst(0);
                            startAnimLast(items.length - 1);
                        }
                        if (targetCb.classList.contains('js-anim-about-inflammation')) {
                            const container = targetCb;
                            const items = container.querySelectorAll('.js-anim-about-inflammation-item');
                            const value = window.innerWidth / 10;

                            const tl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: container,
                                    scrub: true,
                                    start: `${-window.innerHeight / 1.5} top`,
                                    end: () => "+=" + container.clientHeight,
                                }
                            });

                            for (let index = 0; index < items.length; index++) {
                                const element = items[index];
                                element.style.transitionDuration = '0s'
                                let valueY = value;

                                if (index === 1) {
                                    valueY = value / 3;
                                }

                                if (index === 2) {
                                    valueY = value / 1.5;
                                }

                                tl.fromTo(element, { y: valueY }, { y: -valueY }, "<");
                            }
                        }

                        // window.lennis.on('scroll', ScrollTrigger.update)
                    }
                })

                if (targetCb.classList.contains('js-growth-inflammation')) {
                    const container = document.querySelector('.js-growth-inflammation-wrapper');
                    const imageWrapper = container.querySelector('.js-growth-inflammation-img');
                    const folder = window.innerWidth > 767 ? 'growth-inflammation' : 'growth-inflammation-mob';

                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: container,
                            scrub: true,
                            start: `top-=${window.innerHeight / 2} top`,
                            end: () => "+=" + container.clientHeight,
                        }
                    });

                    console.time()

                    for (let index = 1; index < 81; index++) {
                        const image = document.createElement('IMG');

                        image.src = `/media/images/${folder}/${index}.jpg`;
                        imageWrapper.append(image);

                        tl.to(image, { visibility: 'visible', ease: 'linear' });
                    }

                    console.timeEnd()
                }

                // if (window.lennis) {
                //     window.lennis.on('scroll', ScrollTrigger.update);
                // }

                targetCb && typeof targetCb === "function" && targetCb();
            }
        }

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, itsoftApp.libraries.scrollTrigger);
    }

    module.callback = initScrollActions;
});


